var map = {
	"./af/analysis": [
		65141,
		65141
	],
	"./af/analysis.json": [
		65141,
		65141
	],
	"./af/challenge": [
		37232,
		37232
	],
	"./af/challenge.json": [
		37232,
		37232
	],
	"./af/common": [
		51301,
		51301
	],
	"./af/common.json": [
		51301,
		51301
	],
	"./af/friends": [
		35778,
		35778
	],
	"./af/friends.json": [
		35778,
		35778
	],
	"./af/home": [
		42460,
		42460
	],
	"./af/home.json": [
		42460,
		42460
	],
	"./af/leagues": [
		74109,
		74109
	],
	"./af/leagues.json": [
		74109,
		74109
	],
	"./af/lobby": [
		43893,
		43893
	],
	"./af/lobby.json": [
		43893,
		43893
	],
	"./af/players": [
		98978,
		98978
	],
	"./af/players.json": [
		98978,
		98978
	],
	"./af/profile": [
		6490,
		6490
	],
	"./af/profile.json": [
		6490,
		6490
	],
	"./af/puzzle": [
		96503,
		96503
	],
	"./af/puzzle.json": [
		96503,
		96503
	],
	"./af/register": [
		63985,
		63985
	],
	"./af/register.json": [
		63985,
		63985
	],
	"./af/settings": [
		51273,
		51273
	],
	"./af/settings.json": [
		51273,
		51273
	],
	"./ar/analysis": [
		48354,
		48354
	],
	"./ar/analysis.json": [
		48354,
		48354
	],
	"./ar/challenge": [
		77622,
		77622
	],
	"./ar/challenge.json": [
		77622,
		77622
	],
	"./ar/common": [
		11111,
		11111
	],
	"./ar/common.json": [
		11111,
		11111
	],
	"./ar/friends": [
		14456,
		14456
	],
	"./ar/friends.json": [
		14456,
		14456
	],
	"./ar/home": [
		50609,
		50609
	],
	"./ar/home.json": [
		50609,
		50609
	],
	"./ar/leagues": [
		54829,
		54829
	],
	"./ar/leagues.json": [
		54829,
		54829
	],
	"./ar/lobby": [
		7236,
		7236
	],
	"./ar/lobby.json": [
		7236,
		7236
	],
	"./ar/players": [
		62705,
		62705
	],
	"./ar/players.json": [
		62705,
		62705
	],
	"./ar/profile": [
		45340,
		45340
	],
	"./ar/profile.json": [
		45340,
		45340
	],
	"./ar/puzzle": [
		23915,
		23915
	],
	"./ar/puzzle.json": [
		23915,
		23915
	],
	"./ar/register": [
		11448,
		11448
	],
	"./ar/register.json": [
		11448,
		11448
	],
	"./ar/settings": [
		3937,
		3937
	],
	"./ar/settings.json": [
		3937,
		3937
	],
	"./az/analysis": [
		74477,
		74477
	],
	"./az/analysis.json": [
		74477,
		74477
	],
	"./az/challenge": [
		96122,
		96122
	],
	"./az/challenge.json": [
		96122,
		96122
	],
	"./az/common": [
		69579,
		69579
	],
	"./az/common.json": [
		69579,
		69579
	],
	"./az/friends": [
		85464,
		85464
	],
	"./az/friends.json": [
		85464,
		85464
	],
	"./az/home": [
		35017,
		35017
	],
	"./az/home.json": [
		35017,
		35017
	],
	"./az/leagues": [
		50195,
		90839
	],
	"./az/leagues.json": [
		50195,
		90839
	],
	"./az/lobby": [
		80002,
		80002
	],
	"./az/lobby.json": [
		80002,
		80002
	],
	"./az/players": [
		47038,
		47038
	],
	"./az/players.json": [
		47038,
		47038
	],
	"./az/profile": [
		13757,
		13757
	],
	"./az/profile.json": [
		13757,
		13757
	],
	"./az/puzzle": [
		31262,
		31262
	],
	"./az/puzzle.json": [
		31262,
		31262
	],
	"./az/register": [
		6873,
		6873
	],
	"./az/register.json": [
		6873,
		6873
	],
	"./az/settings": [
		2937,
		2937
	],
	"./az/settings.json": [
		2937,
		2937
	],
	"./be/analysis": [
		27793,
		27793
	],
	"./be/analysis.json": [
		27793,
		27793
	],
	"./be/challenge": [
		11210,
		11210
	],
	"./be/challenge.json": [
		11210,
		11210
	],
	"./be/common": [
		68714,
		68714
	],
	"./be/common.json": [
		68714,
		68714
	],
	"./be/friends": [
		81764,
		81764
	],
	"./be/friends.json": [
		81764,
		81764
	],
	"./be/home": [
		44609,
		44609
	],
	"./be/home.json": [
		44609,
		44609
	],
	"./be/leagues": [
		13760,
		13760
	],
	"./be/leagues.json": [
		13760,
		13760
	],
	"./be/lobby": [
		70995,
		70995
	],
	"./be/lobby.json": [
		70995,
		70995
	],
	"./be/players": [
		33678,
		33678
	],
	"./be/players.json": [
		33678,
		33678
	],
	"./be/profile": [
		2503,
		2503
	],
	"./be/profile.json": [
		2503,
		2503
	],
	"./be/puzzle": [
		65307,
		65307
	],
	"./be/puzzle.json": [
		65307,
		65307
	],
	"./be/register": [
		7650,
		7650
	],
	"./be/register.json": [
		7650,
		7650
	],
	"./be/settings": [
		75629,
		75629
	],
	"./be/settings.json": [
		75629,
		75629
	],
	"./bg/analysis": [
		90178,
		90178
	],
	"./bg/analysis.json": [
		90178,
		90178
	],
	"./bg/challenge": [
		57881,
		57881
	],
	"./bg/challenge.json": [
		57881,
		57881
	],
	"./bg/common": [
		26564,
		26564
	],
	"./bg/common.json": [
		26564,
		26564
	],
	"./bg/friends": [
		69815,
		69815
	],
	"./bg/friends.json": [
		69815,
		69815
	],
	"./bg/home": [
		87025,
		87025
	],
	"./bg/home.json": [
		87025,
		87025
	],
	"./bg/leagues": [
		83534,
		83534
	],
	"./bg/leagues.json": [
		83534,
		83534
	],
	"./bg/lobby": [
		6009,
		6009
	],
	"./bg/lobby.json": [
		6009,
		6009
	],
	"./bg/players": [
		36950,
		36950
	],
	"./bg/players.json": [
		36950,
		36950
	],
	"./bg/profile": [
		11874,
		11874
	],
	"./bg/profile.json": [
		11874,
		11874
	],
	"./bg/puzzle": [
		81534,
		81534
	],
	"./bg/puzzle.json": [
		81534,
		81534
	],
	"./bg/register": [
		55635,
		55635
	],
	"./bg/register.json": [
		55635,
		55635
	],
	"./bg/settings": [
		79326,
		79326
	],
	"./bg/settings.json": [
		79326,
		79326
	],
	"./bn/analysis": [
		63022,
		63022
	],
	"./bn/analysis.json": [
		63022,
		63022
	],
	"./bn/challenge": [
		42128,
		42128
	],
	"./bn/challenge.json": [
		42128,
		42128
	],
	"./bn/common": [
		50371,
		50371
	],
	"./bn/common.json": [
		50371,
		50371
	],
	"./bn/friends": [
		24290,
		24290
	],
	"./bn/friends.json": [
		24290,
		24290
	],
	"./bn/home": [
		82481,
		82481
	],
	"./bn/home.json": [
		82481,
		82481
	],
	"./bn/leagues": [
		79506,
		79506
	],
	"./bn/leagues.json": [
		79506,
		79506
	],
	"./bn/lobby": [
		64102,
		64102
	],
	"./bn/lobby.json": [
		64102,
		64102
	],
	"./bn/players": [
		28837,
		28837
	],
	"./bn/players.json": [
		28837,
		28837
	],
	"./bn/profile": [
		10188,
		10188
	],
	"./bn/profile.json": [
		10188,
		10188
	],
	"./bn/puzzle": [
		55690,
		55690
	],
	"./bn/puzzle.json": [
		55690,
		55690
	],
	"./bn/register": [
		24226,
		24226
	],
	"./bn/register.json": [
		24226,
		24226
	],
	"./bn/settings": [
		90827,
		90827
	],
	"./bn/settings.json": [
		90827,
		90827
	],
	"./bs/analysis": [
		80430,
		80430
	],
	"./bs/analysis.json": [
		80430,
		80430
	],
	"./bs/challenge": [
		96517,
		96517
	],
	"./bs/challenge.json": [
		96517,
		96517
	],
	"./bs/common": [
		62752,
		62752
	],
	"./bs/common.json": [
		62752,
		62752
	],
	"./bs/friends": [
		38087,
		38087
	],
	"./bs/friends.json": [
		38087,
		38087
	],
	"./bs/home": [
		82201,
		82201
	],
	"./bs/home.json": [
		82201,
		82201
	],
	"./bs/leagues": [
		35271,
		35271
	],
	"./bs/leagues.json": [
		35271,
		35271
	],
	"./bs/lobby": [
		17407,
		17407
	],
	"./bs/lobby.json": [
		17407,
		17407
	],
	"./bs/players": [
		92365,
		92365
	],
	"./bs/players.json": [
		92365,
		92365
	],
	"./bs/profile": [
		14751,
		14751
	],
	"./bs/profile.json": [
		14751,
		14751
	],
	"./bs/puzzle": [
		6399,
		6399
	],
	"./bs/puzzle.json": [
		6399,
		6399
	],
	"./bs/register": [
		55541,
		55541
	],
	"./bs/register.json": [
		55541,
		55541
	],
	"./bs/settings": [
		56884,
		56884
	],
	"./bs/settings.json": [
		56884,
		56884
	],
	"./ca/analysis": [
		85938,
		85938
	],
	"./ca/analysis.json": [
		85938,
		85938
	],
	"./ca/challenge": [
		13852,
		13852
	],
	"./ca/challenge.json": [
		13852,
		13852
	],
	"./ca/common": [
		59706,
		59706
	],
	"./ca/common.json": [
		59706,
		59706
	],
	"./ca/friends": [
		4192,
		4192
	],
	"./ca/friends.json": [
		4192,
		4192
	],
	"./ca/home": [
		75354,
		75354
	],
	"./ca/home.json": [
		75354,
		75354
	],
	"./ca/leagues": [
		68821,
		68821
	],
	"./ca/leagues.json": [
		68821,
		68821
	],
	"./ca/lobby": [
		51608,
		51608
	],
	"./ca/lobby.json": [
		51608,
		51608
	],
	"./ca/players": [
		57264,
		57264
	],
	"./ca/players.json": [
		57264,
		57264
	],
	"./ca/profile": [
		92156,
		92156
	],
	"./ca/profile.json": [
		92156,
		92156
	],
	"./ca/puzzle": [
		67620,
		67620
	],
	"./ca/puzzle.json": [
		67620,
		67620
	],
	"./ca/register": [
		40078,
		40078
	],
	"./ca/register.json": [
		40078,
		40078
	],
	"./ca/settings": [
		14078,
		14078
	],
	"./ca/settings.json": [
		14078,
		14078
	],
	"./cs/analysis": [
		10983,
		10983
	],
	"./cs/analysis.json": [
		10983,
		10983
	],
	"./cs/challenge": [
		75096,
		75096
	],
	"./cs/challenge.json": [
		75096,
		75096
	],
	"./cs/common": [
		38913,
		38913
	],
	"./cs/common.json": [
		38913,
		38913
	],
	"./cs/friends": [
		76813,
		76813
	],
	"./cs/friends.json": [
		76813,
		76813
	],
	"./cs/home": [
		19786,
		19786
	],
	"./cs/home.json": [
		19786,
		19786
	],
	"./cs/leagues": [
		3381,
		3381
	],
	"./cs/leagues.json": [
		3381,
		3381
	],
	"./cs/lobby": [
		85036,
		85036
	],
	"./cs/lobby.json": [
		85036,
		85036
	],
	"./cs/players": [
		26904,
		26904
	],
	"./cs/players.json": [
		26904,
		26904
	],
	"./cs/profile": [
		11383,
		11383
	],
	"./cs/profile.json": [
		11383,
		11383
	],
	"./cs/puzzle": [
		16108,
		16108
	],
	"./cs/puzzle.json": [
		16108,
		16108
	],
	"./cs/register": [
		45587,
		45587
	],
	"./cs/register.json": [
		45587,
		45587
	],
	"./cs/settings": [
		54967,
		54967
	],
	"./cs/settings.json": [
		54967,
		54967
	],
	"./da/analysis": [
		19953,
		19953
	],
	"./da/analysis.json": [
		19953,
		19953
	],
	"./da/challenge": [
		60963,
		60963
	],
	"./da/challenge.json": [
		60963,
		60963
	],
	"./da/common": [
		7682,
		7682
	],
	"./da/common.json": [
		7682,
		7682
	],
	"./da/friends": [
		57888,
		57888
	],
	"./da/friends.json": [
		57888,
		57888
	],
	"./da/home": [
		52717,
		52717
	],
	"./da/home.json": [
		52717,
		52717
	],
	"./da/leagues": [
		24432,
		24432
	],
	"./da/leagues.json": [
		24432,
		24432
	],
	"./da/lobby": [
		62449,
		62449
	],
	"./da/lobby.json": [
		62449,
		62449
	],
	"./da/players": [
		87110,
		87110
	],
	"./da/players.json": [
		87110,
		87110
	],
	"./da/profile": [
		66656,
		66656
	],
	"./da/profile.json": [
		66656,
		66656
	],
	"./da/puzzle": [
		25910,
		25910
	],
	"./da/puzzle.json": [
		25910,
		25910
	],
	"./da/register": [
		19760,
		19760
	],
	"./da/register.json": [
		19760,
		19760
	],
	"./da/settings": [
		80620,
		80620
	],
	"./da/settings.json": [
		80620,
		80620
	],
	"./de/analysis": [
		64106,
		64106
	],
	"./de/analysis.json": [
		64106,
		64106
	],
	"./de/challenge": [
		63147,
		63147
	],
	"./de/challenge.json": [
		63147,
		63147
	],
	"./de/common": [
		21545,
		21545
	],
	"./de/common.json": [
		21545,
		21545
	],
	"./de/friends": [
		74499,
		48814
	],
	"./de/friends.json": [
		74499,
		48814
	],
	"./de/gamePlay": [
		22600,
		22600
	],
	"./de/gamePlay.json": [
		22600,
		22600
	],
	"./de/home": [
		18948,
		18948
	],
	"./de/home.json": [
		18948,
		18948
	],
	"./de/leagues": [
		21317,
		21317
	],
	"./de/leagues.json": [
		21317,
		21317
	],
	"./de/lobby": [
		55868,
		55868
	],
	"./de/lobby.json": [
		55868,
		55868
	],
	"./de/players": [
		61210,
		61210
	],
	"./de/players.json": [
		61210,
		61210
	],
	"./de/profile": [
		24234,
		24234
	],
	"./de/profile.json": [
		24234,
		24234
	],
	"./de/puzzle": [
		10286,
		10286
	],
	"./de/puzzle.json": [
		10286,
		10286
	],
	"./de/register": [
		7622,
		7622
	],
	"./de/register.json": [
		7622,
		7622
	],
	"./de/settings": [
		81969,
		81969
	],
	"./de/settings.json": [
		81969,
		81969
	],
	"./el/analysis": [
		49839,
		49839
	],
	"./el/analysis.json": [
		49839,
		49839
	],
	"./el/challenge": [
		59892,
		59892
	],
	"./el/challenge.json": [
		59892,
		59892
	],
	"./el/common": [
		3319,
		3319
	],
	"./el/common.json": [
		3319,
		3319
	],
	"./el/friends": [
		91918,
		91918
	],
	"./el/friends.json": [
		91918,
		91918
	],
	"./el/home": [
		70002,
		70002
	],
	"./el/home.json": [
		70002,
		70002
	],
	"./el/leagues": [
		12118,
		12118
	],
	"./el/leagues.json": [
		12118,
		12118
	],
	"./el/lobby": [
		940,
		940
	],
	"./el/lobby.json": [
		940,
		940
	],
	"./el/players": [
		14543,
		14543
	],
	"./el/players.json": [
		14543,
		14543
	],
	"./el/profile": [
		5694,
		5694
	],
	"./el/profile.json": [
		5694,
		5694
	],
	"./el/puzzle": [
		24235,
		24235
	],
	"./el/puzzle.json": [
		24235,
		24235
	],
	"./el/register": [
		68883,
		68883
	],
	"./el/register.json": [
		68883,
		68883
	],
	"./el/settings": [
		52031,
		52031
	],
	"./el/settings.json": [
		52031,
		52031
	],
	"./en/analysis": [
		96306,
		96306
	],
	"./en/analysis.json": [
		96306,
		96306
	],
	"./en/category": [
		25971,
		25971
	],
	"./en/category.json": [
		25971,
		25971
	],
	"./en/challenge": [
		46000,
		46000
	],
	"./en/challenge.json": [
		46000,
		46000
	],
	"./en/common": [
		40464,
		40464
	],
	"./en/common.json": [
		40464,
		40464
	],
	"./en/friends": [
		78832,
		78832
	],
	"./en/friends.json": [
		78832,
		78832
	],
	"./en/gamePlay": [
		26933,
		26933
	],
	"./en/gamePlay.json": [
		26933,
		26933
	],
	"./en/home": [
		12482,
		12482
	],
	"./en/home.json": [
		12482,
		12482
	],
	"./en/leagues": [
		10075,
		10075
	],
	"./en/leagues.json": [
		10075,
		10075
	],
	"./en/lobby": [
		64689,
		64689
	],
	"./en/lobby.json": [
		64689,
		64689
	],
	"./en/notUsed/correspondence": [
		34513,
		34513
	],
	"./en/notUsed/correspondence.json": [
		34513,
		34513
	],
	"./en/notUsed/notUsed": [
		7883,
		7883
	],
	"./en/notUsed/notUsed.json": [
		7883,
		7883
	],
	"./en/players": [
		97458,
		97458
	],
	"./en/players.json": [
		97458,
		97458
	],
	"./en/profile": [
		81140,
		81140
	],
	"./en/profile.json": [
		81140,
		81140
	],
	"./en/puzzle": [
		13442,
		13442
	],
	"./en/puzzle.json": [
		13442,
		13442
	],
	"./en/register": [
		32946,
		32946
	],
	"./en/register.json": [
		32946,
		32946
	],
	"./en/settings": [
		64408,
		64408
	],
	"./en/settings.json": [
		64408,
		64408
	],
	"./es/analysis": [
		74336,
		74336
	],
	"./es/analysis.json": [
		74336,
		74336
	],
	"./es/challenge": [
		64887,
		64887
	],
	"./es/challenge.json": [
		64887,
		64887
	],
	"./es/common": [
		10357,
		10357
	],
	"./es/common.json": [
		10357,
		10357
	],
	"./es/friends": [
		98679,
		98679
	],
	"./es/friends.json": [
		98679,
		98679
	],
	"./es/gamePlay": [
		6324,
		6324
	],
	"./es/gamePlay.json": [
		6324,
		6324
	],
	"./es/home": [
		76891,
		76891
	],
	"./es/home.json": [
		76891,
		76891
	],
	"./es/leagues": [
		5171,
		5171
	],
	"./es/leagues.json": [
		5171,
		5171
	],
	"./es/lobby": [
		78748,
		78748
	],
	"./es/lobby.json": [
		78748,
		78748
	],
	"./es/navigation": [
		49389,
		49389
	],
	"./es/navigation.json": [
		49389,
		49389
	],
	"./es/notUsed/correspondence": [
		23584,
		23584
	],
	"./es/notUsed/correspondence.json": [
		23584,
		23584
	],
	"./es/notUsed/notUsed": [
		79069,
		79069
	],
	"./es/notUsed/notUsed.json": [
		79069,
		79069
	],
	"./es/players": [
		29450,
		29450
	],
	"./es/players.json": [
		29450,
		29450
	],
	"./es/profile": [
		54160,
		54160
	],
	"./es/profile.json": [
		54160,
		54160
	],
	"./es/puzzle": [
		79995,
		79995
	],
	"./es/puzzle.json": [
		79995,
		79995
	],
	"./es/register": [
		45852,
		45852
	],
	"./es/register.json": [
		45852,
		45852
	],
	"./es/settings": [
		61987,
		61987
	],
	"./es/settings.json": [
		61987,
		61987
	],
	"./et/analysis": [
		80737,
		80737
	],
	"./et/analysis.json": [
		80737,
		80737
	],
	"./et/challenge": [
		92689,
		92689
	],
	"./et/challenge.json": [
		92689,
		92689
	],
	"./et/common": [
		61646,
		61646
	],
	"./et/common.json": [
		61646,
		61646
	],
	"./et/friends": [
		60669,
		60669
	],
	"./et/friends.json": [
		60669,
		60669
	],
	"./et/home": [
		8994,
		8994
	],
	"./et/home.json": [
		8994,
		8994
	],
	"./et/leagues": [
		33426,
		33426
	],
	"./et/leagues.json": [
		33426,
		33426
	],
	"./et/lobby": [
		76461,
		76461
	],
	"./et/lobby.json": [
		76461,
		76461
	],
	"./et/players": [
		3288,
		3288
	],
	"./et/players.json": [
		3288,
		3288
	],
	"./et/profile": [
		20817,
		20817
	],
	"./et/profile.json": [
		20817,
		20817
	],
	"./et/puzzle": [
		85703,
		85703
	],
	"./et/puzzle.json": [
		85703,
		85703
	],
	"./et/register": [
		65697,
		65697
	],
	"./et/register.json": [
		65697,
		65697
	],
	"./et/settings": [
		11552,
		11552
	],
	"./et/settings.json": [
		11552,
		11552
	],
	"./fa/analysis": [
		67744,
		67744
	],
	"./fa/analysis.json": [
		67744,
		67744
	],
	"./fa/challenge": [
		79850,
		79850
	],
	"./fa/challenge.json": [
		79850,
		79850
	],
	"./fa/common": [
		70512,
		70512
	],
	"./fa/common.json": [
		70512,
		70512
	],
	"./fa/friends": [
		96642,
		96642
	],
	"./fa/friends.json": [
		96642,
		96642
	],
	"./fa/home": [
		17859,
		17859
	],
	"./fa/home.json": [
		17859,
		17859
	],
	"./fa/leagues": [
		89977,
		89977
	],
	"./fa/leagues.json": [
		89977,
		89977
	],
	"./fa/lobby": [
		32156,
		32156
	],
	"./fa/lobby.json": [
		32156,
		32156
	],
	"./fa/players": [
		45981,
		45981
	],
	"./fa/players.json": [
		45981,
		45981
	],
	"./fa/profile": [
		92620,
		92620
	],
	"./fa/profile.json": [
		92620,
		92620
	],
	"./fa/puzzle": [
		26824,
		26824
	],
	"./fa/puzzle.json": [
		26824,
		26824
	],
	"./fa/register": [
		24067,
		24067
	],
	"./fa/register.json": [
		24067,
		24067
	],
	"./fa/settings": [
		81763,
		81763
	],
	"./fa/settings.json": [
		81763,
		81763
	],
	"./fi/analysis": [
		74929,
		74929
	],
	"./fi/analysis.json": [
		74929,
		74929
	],
	"./fi/challenge": [
		36641,
		36641
	],
	"./fi/challenge.json": [
		36641,
		36641
	],
	"./fi/common": [
		8418,
		8418
	],
	"./fi/common.json": [
		8418,
		8418
	],
	"./fi/friends": [
		71777,
		71777
	],
	"./fi/friends.json": [
		71777,
		71777
	],
	"./fi/home": [
		32771,
		32771
	],
	"./fi/home.json": [
		32771,
		32771
	],
	"./fi/leagues": [
		351,
		351
	],
	"./fi/leagues.json": [
		351,
		351
	],
	"./fi/lobby": [
		60501,
		60501
	],
	"./fi/lobby.json": [
		60501,
		60501
	],
	"./fi/players": [
		81910,
		81910
	],
	"./fi/players.json": [
		81910,
		81910
	],
	"./fi/profile": [
		5831,
		5831
	],
	"./fi/profile.json": [
		5831,
		5831
	],
	"./fi/puzzle": [
		83547,
		83547
	],
	"./fi/puzzle.json": [
		83547,
		83547
	],
	"./fi/register": [
		68981,
		68981
	],
	"./fi/register.json": [
		68981,
		68981
	],
	"./fi/settings": [
		80094,
		80094
	],
	"./fi/settings.json": [
		80094,
		80094
	],
	"./fr/analysis": [
		19977,
		19977
	],
	"./fr/analysis.json": [
		19977,
		19977
	],
	"./fr/category": [
		19864,
		19864
	],
	"./fr/category.json": [
		19864,
		19864
	],
	"./fr/challenge": [
		85087,
		85087
	],
	"./fr/challenge.json": [
		85087,
		85087
	],
	"./fr/common": [
		45167,
		45167
	],
	"./fr/common.json": [
		45167,
		45167
	],
	"./fr/friends": [
		66481,
		66481
	],
	"./fr/friends.json": [
		66481,
		66481
	],
	"./fr/gamePlay": [
		31183,
		31183
	],
	"./fr/gamePlay.json": [
		31183,
		31183
	],
	"./fr/home": [
		31660,
		31660
	],
	"./fr/home.json": [
		31660,
		31660
	],
	"./fr/leagues": [
		76674,
		76674
	],
	"./fr/leagues.json": [
		76674,
		76674
	],
	"./fr/lobby": [
		18853,
		18853
	],
	"./fr/lobby.json": [
		18853,
		18853
	],
	"./fr/notUsed/daily": [
		55624,
		55624
	],
	"./fr/notUsed/daily.json": [
		55624,
		55624
	],
	"./fr/notUsed/extra": [
		38010,
		38010
	],
	"./fr/notUsed/extra.json": [
		38010,
		38010
	],
	"./fr/notUsed/navigation": [
		29404,
		29404
	],
	"./fr/notUsed/navigation.json": [
		29404,
		29404
	],
	"./fr/notUsed/notUsed": [
		83656,
		83656
	],
	"./fr/notUsed/notUsed.json": [
		83656,
		83656
	],
	"./fr/players": [
		57779,
		57779
	],
	"./fr/players.json": [
		57779,
		57779
	],
	"./fr/profile": [
		51763,
		51763
	],
	"./fr/profile.json": [
		51763,
		51763
	],
	"./fr/puzzle": [
		65454,
		65454
	],
	"./fr/puzzle.json": [
		65454,
		65454
	],
	"./fr/register": [
		10205,
		10205
	],
	"./fr/register.json": [
		10205,
		10205
	],
	"./fr/settings": [
		51326,
		51326
	],
	"./fr/settings.json": [
		51326,
		51326
	],
	"./gl/analysis": [
		77548,
		77548
	],
	"./gl/analysis.json": [
		77548,
		77548
	],
	"./gl/challenge": [
		34708,
		34708
	],
	"./gl/challenge.json": [
		34708,
		34708
	],
	"./gl/common": [
		91362,
		91362
	],
	"./gl/common.json": [
		91362,
		91362
	],
	"./gl/friends": [
		2356,
		2356
	],
	"./gl/friends.json": [
		2356,
		2356
	],
	"./gl/home": [
		29255,
		29255
	],
	"./gl/home.json": [
		29255,
		29255
	],
	"./gl/leagues": [
		12470,
		12470
	],
	"./gl/leagues.json": [
		12470,
		12470
	],
	"./gl/lobby": [
		80478,
		80478
	],
	"./gl/lobby.json": [
		80478,
		80478
	],
	"./gl/players": [
		57643,
		57643
	],
	"./gl/players.json": [
		57643,
		57643
	],
	"./gl/profile": [
		72878,
		72878
	],
	"./gl/profile.json": [
		72878,
		72878
	],
	"./gl/puzzle": [
		35518,
		35518
	],
	"./gl/puzzle.json": [
		35518,
		35518
	],
	"./gl/register": [
		73314,
		73314
	],
	"./gl/register.json": [
		73314,
		73314
	],
	"./gl/settings": [
		15327,
		15327
	],
	"./gl/settings.json": [
		15327,
		15327
	],
	"./gu/analysis": [
		79684,
		79684
	],
	"./gu/analysis.json": [
		79684,
		79684
	],
	"./gu/challenge": [
		84045,
		84045
	],
	"./gu/challenge.json": [
		84045,
		84045
	],
	"./gu/common": [
		24365,
		24365
	],
	"./gu/common.json": [
		24365,
		24365
	],
	"./gu/friends": [
		53102,
		53102
	],
	"./gu/friends.json": [
		53102,
		53102
	],
	"./gu/home": [
		11369,
		11369
	],
	"./gu/home.json": [
		11369,
		11369
	],
	"./gu/leagues": [
		38620,
		38620
	],
	"./gu/leagues.json": [
		38620,
		38620
	],
	"./gu/lobby": [
		57223,
		57223
	],
	"./gu/lobby.json": [
		57223,
		57223
	],
	"./gu/players": [
		67932,
		67932
	],
	"./gu/players.json": [
		67932,
		67932
	],
	"./gu/profile": [
		93453,
		93453
	],
	"./gu/profile.json": [
		93453,
		93453
	],
	"./gu/puzzle": [
		16375,
		16375
	],
	"./gu/puzzle.json": [
		16375,
		16375
	],
	"./gu/register": [
		44139,
		44139
	],
	"./gu/register.json": [
		44139,
		44139
	],
	"./gu/settings": [
		21504,
		21504
	],
	"./gu/settings.json": [
		21504,
		21504
	],
	"./he/analysis": [
		63633,
		63633
	],
	"./he/analysis.json": [
		63633,
		63633
	],
	"./he/challenge": [
		30473,
		30473
	],
	"./he/challenge.json": [
		30473,
		30473
	],
	"./he/common": [
		15657,
		15657
	],
	"./he/common.json": [
		15657,
		15657
	],
	"./he/friends": [
		50755,
		50755
	],
	"./he/friends.json": [
		50755,
		50755
	],
	"./he/home": [
		41593,
		41593
	],
	"./he/home.json": [
		41593,
		41593
	],
	"./he/leagues": [
		62790,
		62790
	],
	"./he/leagues.json": [
		62790,
		62790
	],
	"./he/lobby": [
		52009,
		52009
	],
	"./he/lobby.json": [
		52009,
		52009
	],
	"./he/players": [
		43511,
		43511
	],
	"./he/players.json": [
		43511,
		43511
	],
	"./he/profile": [
		55103,
		55103
	],
	"./he/profile.json": [
		55103,
		55103
	],
	"./he/puzzle": [
		34042,
		34042
	],
	"./he/puzzle.json": [
		34042,
		34042
	],
	"./he/register": [
		77404,
		77404
	],
	"./he/register.json": [
		77404,
		77404
	],
	"./he/settings": [
		87332,
		87332
	],
	"./he/settings.json": [
		87332,
		87332
	],
	"./hi/analysis": [
		77362,
		77362
	],
	"./hi/analysis.json": [
		77362,
		77362
	],
	"./hi/challenge": [
		26437,
		26437
	],
	"./hi/challenge.json": [
		26437,
		26437
	],
	"./hi/common": [
		26729,
		26729
	],
	"./hi/common.json": [
		26729,
		26729
	],
	"./hi/friends": [
		19288,
		19288
	],
	"./hi/friends.json": [
		19288,
		19288
	],
	"./hi/home": [
		18945,
		18945
	],
	"./hi/home.json": [
		18945,
		18945
	],
	"./hi/leagues": [
		85228,
		85228
	],
	"./hi/leagues.json": [
		85228,
		85228
	],
	"./hi/lobby": [
		10123,
		10123
	],
	"./hi/lobby.json": [
		10123,
		10123
	],
	"./hi/players": [
		57566,
		57566
	],
	"./hi/players.json": [
		57566,
		57566
	],
	"./hi/profile": [
		40178,
		40178
	],
	"./hi/profile.json": [
		40178,
		40178
	],
	"./hi/puzzle": [
		59790,
		59790
	],
	"./hi/puzzle.json": [
		59790,
		59790
	],
	"./hi/register": [
		61680,
		61680
	],
	"./hi/register.json": [
		61680,
		61680
	],
	"./hi/settings": [
		94227,
		94227
	],
	"./hi/settings.json": [
		94227,
		94227
	],
	"./hr/analysis": [
		76432,
		76432
	],
	"./hr/analysis.json": [
		76432,
		76432
	],
	"./hr/challenge": [
		53017,
		53017
	],
	"./hr/challenge.json": [
		53017,
		53017
	],
	"./hr/common": [
		22146,
		22146
	],
	"./hr/common.json": [
		22146,
		22146
	],
	"./hr/friends": [
		67443,
		67443
	],
	"./hr/friends.json": [
		67443,
		67443
	],
	"./hr/home": [
		73674,
		73674
	],
	"./hr/home.json": [
		73674,
		73674
	],
	"./hr/leagues": [
		88890,
		88890
	],
	"./hr/leagues.json": [
		88890,
		88890
	],
	"./hr/lobby": [
		98667,
		98667
	],
	"./hr/lobby.json": [
		98667,
		98667
	],
	"./hr/players": [
		16712,
		16712
	],
	"./hr/players.json": [
		16712,
		16712
	],
	"./hr/profile": [
		60699,
		60699
	],
	"./hr/profile.json": [
		60699,
		60699
	],
	"./hr/puzzle": [
		391,
		391
	],
	"./hr/puzzle.json": [
		391,
		391
	],
	"./hr/register": [
		58674,
		58674
	],
	"./hr/register.json": [
		58674,
		58674
	],
	"./hr/settings": [
		19596,
		19596
	],
	"./hr/settings.json": [
		19596,
		19596
	],
	"./hu/analysis": [
		62965,
		62965
	],
	"./hu/analysis.json": [
		62965,
		62965
	],
	"./hu/challenge": [
		75,
		75
	],
	"./hu/challenge.json": [
		75,
		75
	],
	"./hu/common": [
		85474,
		85474
	],
	"./hu/common.json": [
		85474,
		85474
	],
	"./hu/friends": [
		20188,
		20188
	],
	"./hu/friends.json": [
		20188,
		20188
	],
	"./hu/home": [
		47352,
		47352
	],
	"./hu/home.json": [
		47352,
		47352
	],
	"./hu/leagues": [
		48581,
		48581
	],
	"./hu/leagues.json": [
		48581,
		48581
	],
	"./hu/lobby": [
		59612,
		59612
	],
	"./hu/lobby.json": [
		59612,
		59612
	],
	"./hu/players": [
		20896,
		20896
	],
	"./hu/players.json": [
		20896,
		20896
	],
	"./hu/profile": [
		27517,
		27517
	],
	"./hu/profile.json": [
		27517,
		27517
	],
	"./hu/puzzle": [
		54595,
		54595
	],
	"./hu/puzzle.json": [
		54595,
		54595
	],
	"./hu/register": [
		65639,
		65639
	],
	"./hu/register.json": [
		65639,
		65639
	],
	"./hu/settings": [
		30972,
		30972
	],
	"./hu/settings.json": [
		30972,
		30972
	],
	"./hy/analysis": [
		78708,
		78708
	],
	"./hy/analysis.json": [
		78708,
		78708
	],
	"./hy/challenge": [
		48113,
		48113
	],
	"./hy/challenge.json": [
		48113,
		48113
	],
	"./hy/common": [
		60160,
		60160
	],
	"./hy/common.json": [
		60160,
		60160
	],
	"./hy/friends": [
		58450,
		58450
	],
	"./hy/friends.json": [
		58450,
		58450
	],
	"./hy/home": [
		33577,
		33577
	],
	"./hy/home.json": [
		33577,
		33577
	],
	"./hy/leagues": [
		37031,
		37031
	],
	"./hy/leagues.json": [
		37031,
		37031
	],
	"./hy/lobby": [
		6127,
		6127
	],
	"./hy/lobby.json": [
		6127,
		6127
	],
	"./hy/players": [
		29029,
		29029
	],
	"./hy/players.json": [
		29029,
		29029
	],
	"./hy/profile": [
		56416,
		56416
	],
	"./hy/profile.json": [
		56416,
		56416
	],
	"./hy/puzzle": [
		45402,
		45402
	],
	"./hy/puzzle.json": [
		45402,
		45402
	],
	"./hy/register": [
		39664,
		39664
	],
	"./hy/register.json": [
		39664,
		39664
	],
	"./hy/settings": [
		57318,
		57318
	],
	"./hy/settings.json": [
		57318,
		57318
	],
	"./id/analysis": [
		95471,
		95471
	],
	"./id/analysis.json": [
		95471,
		95471
	],
	"./id/challenge": [
		68476,
		68476
	],
	"./id/challenge.json": [
		68476,
		68476
	],
	"./id/common": [
		81610,
		81610
	],
	"./id/common.json": [
		81610,
		81610
	],
	"./id/friends": [
		10266,
		10266
	],
	"./id/friends.json": [
		10266,
		10266
	],
	"./id/home": [
		96903,
		96903
	],
	"./id/home.json": [
		96903,
		96903
	],
	"./id/leagues": [
		8368,
		8368
	],
	"./id/leagues.json": [
		8368,
		8368
	],
	"./id/lobby": [
		63095,
		63095
	],
	"./id/lobby.json": [
		63095,
		63095
	],
	"./id/players": [
		54940,
		54940
	],
	"./id/players.json": [
		54940,
		54940
	],
	"./id/profile": [
		51702,
		51702
	],
	"./id/profile.json": [
		51702,
		51702
	],
	"./id/puzzle": [
		28721,
		28721
	],
	"./id/puzzle.json": [
		28721,
		28721
	],
	"./id/register": [
		80674,
		80674
	],
	"./id/register.json": [
		80674,
		80674
	],
	"./id/settings": [
		22116,
		22116
	],
	"./id/settings.json": [
		22116,
		22116
	],
	"./is/analysis": [
		38655,
		38655
	],
	"./is/analysis.json": [
		38655,
		38655
	],
	"./is/challenge": [
		64061,
		64061
	],
	"./is/challenge.json": [
		64061,
		64061
	],
	"./is/common": [
		53895,
		53895
	],
	"./is/common.json": [
		53895,
		53895
	],
	"./is/friends": [
		58129,
		58129
	],
	"./is/friends.json": [
		58129,
		58129
	],
	"./is/home": [
		14086,
		34815
	],
	"./is/home.json": [
		14086,
		34815
	],
	"./is/leagues": [
		56891,
		56891
	],
	"./is/leagues.json": [
		56891,
		56891
	],
	"./is/lobby": [
		38420,
		38420
	],
	"./is/lobby.json": [
		38420,
		38420
	],
	"./is/players": [
		30697,
		30697
	],
	"./is/players.json": [
		30697,
		30697
	],
	"./is/profile": [
		36090,
		36090
	],
	"./is/profile.json": [
		36090,
		36090
	],
	"./is/puzzle": [
		65425,
		65425
	],
	"./is/puzzle.json": [
		65425,
		65425
	],
	"./is/register": [
		65672,
		65672
	],
	"./is/register.json": [
		65672,
		65672
	],
	"./is/settings": [
		16237,
		16237
	],
	"./is/settings.json": [
		16237,
		16237
	],
	"./it/analysis": [
		24873,
		24873
	],
	"./it/analysis.json": [
		24873,
		24873
	],
	"./it/challenge": [
		97763,
		97763
	],
	"./it/challenge.json": [
		97763,
		97763
	],
	"./it/common": [
		9486,
		9486
	],
	"./it/common.json": [
		9486,
		9486
	],
	"./it/friends": [
		54169,
		54169
	],
	"./it/friends.json": [
		54169,
		54169
	],
	"./it/gamePlay": [
		20958,
		50195
	],
	"./it/gamePlay.json": [
		20958,
		50195
	],
	"./it/home": [
		53765,
		53765
	],
	"./it/home.json": [
		53765,
		53765
	],
	"./it/leagues": [
		89415,
		89415
	],
	"./it/leagues.json": [
		89415,
		89415
	],
	"./it/lobby": [
		38754,
		38754
	],
	"./it/lobby.json": [
		38754,
		38754
	],
	"./it/notUsed/daily": [
		26882,
		26882
	],
	"./it/notUsed/daily.json": [
		26882,
		26882
	],
	"./it/notUsed/extra": [
		39099,
		39099
	],
	"./it/notUsed/extra.json": [
		39099,
		39099
	],
	"./it/notUsed/navigation": [
		83955,
		20729
	],
	"./it/notUsed/navigation.json": [
		83955,
		20729
	],
	"./it/notUsed/notUsed": [
		54371,
		54371
	],
	"./it/notUsed/notUsed.json": [
		54371,
		54371
	],
	"./it/players": [
		36900,
		36900
	],
	"./it/players.json": [
		36900,
		36900
	],
	"./it/profile": [
		21618,
		21618
	],
	"./it/profile.json": [
		21618,
		21618
	],
	"./it/puzzle": [
		6118,
		6118
	],
	"./it/puzzle.json": [
		6118,
		6118
	],
	"./it/register": [
		48920,
		48920
	],
	"./it/register.json": [
		48920,
		48920
	],
	"./it/settings": [
		98846,
		98846
	],
	"./it/settings.json": [
		98846,
		98846
	],
	"./ja/analysis": [
		44615,
		44615
	],
	"./ja/analysis.json": [
		44615,
		44615
	],
	"./ja/challenge": [
		63502,
		63502
	],
	"./ja/challenge.json": [
		63502,
		63502
	],
	"./ja/common": [
		20459,
		20459
	],
	"./ja/common.json": [
		20459,
		20459
	],
	"./ja/friends": [
		60360,
		60360
	],
	"./ja/friends.json": [
		60360,
		60360
	],
	"./ja/home": [
		68769,
		68769
	],
	"./ja/home.json": [
		68769,
		68769
	],
	"./ja/leagues": [
		65268,
		65268
	],
	"./ja/leagues.json": [
		65268,
		65268
	],
	"./ja/lobby": [
		889,
		889
	],
	"./ja/lobby.json": [
		889,
		889
	],
	"./ja/players": [
		48490,
		48490
	],
	"./ja/players.json": [
		48490,
		48490
	],
	"./ja/profile": [
		39978,
		39978
	],
	"./ja/profile.json": [
		39978,
		39978
	],
	"./ja/puzzle": [
		78798,
		78798
	],
	"./ja/puzzle.json": [
		78798,
		78798
	],
	"./ja/register": [
		28144,
		28144
	],
	"./ja/register.json": [
		28144,
		28144
	],
	"./ja/settings": [
		21700,
		21700
	],
	"./ja/settings.json": [
		21700,
		21700
	],
	"./ka/analysis": [
		71108,
		71108
	],
	"./ka/analysis.json": [
		71108,
		71108
	],
	"./ka/challenge": [
		29306,
		29306
	],
	"./ka/challenge.json": [
		29306,
		29306
	],
	"./ka/common": [
		6290,
		6290
	],
	"./ka/common.json": [
		6290,
		6290
	],
	"./ka/friends": [
		67678,
		67678
	],
	"./ka/friends.json": [
		67678,
		67678
	],
	"./ka/home": [
		23273,
		23273
	],
	"./ka/home.json": [
		23273,
		23273
	],
	"./ka/leagues": [
		22331,
		22331
	],
	"./ka/leagues.json": [
		22331,
		22331
	],
	"./ka/lobby": [
		99986,
		99986
	],
	"./ka/lobby.json": [
		99986,
		99986
	],
	"./ka/players": [
		73166,
		73166
	],
	"./ka/players.json": [
		73166,
		73166
	],
	"./ka/profile": [
		44868,
		44868
	],
	"./ka/profile.json": [
		44868,
		44868
	],
	"./ka/puzzle": [
		26475,
		26475
	],
	"./ka/puzzle.json": [
		26475,
		26475
	],
	"./ka/register": [
		21226,
		21226
	],
	"./ka/register.json": [
		21226,
		21226
	],
	"./ka/settings": [
		53329,
		53329
	],
	"./ka/settings.json": [
		53329,
		53329
	],
	"./kk/analysis": [
		47606,
		47606
	],
	"./kk/analysis.json": [
		47606,
		47606
	],
	"./kk/challenge": [
		68383,
		68383
	],
	"./kk/challenge.json": [
		68383,
		68383
	],
	"./kk/common": [
		68316,
		68316
	],
	"./kk/common.json": [
		68316,
		68316
	],
	"./kk/friends": [
		75569,
		75569
	],
	"./kk/friends.json": [
		75569,
		75569
	],
	"./kk/home": [
		89635,
		89635
	],
	"./kk/home.json": [
		89635,
		89635
	],
	"./kk/leagues": [
		48994,
		48994
	],
	"./kk/leagues.json": [
		48994,
		48994
	],
	"./kk/lobby": [
		97314,
		97314
	],
	"./kk/lobby.json": [
		97314,
		97314
	],
	"./kk/players": [
		36309,
		36309
	],
	"./kk/players.json": [
		36309,
		36309
	],
	"./kk/profile": [
		3486,
		3486
	],
	"./kk/profile.json": [
		3486,
		3486
	],
	"./kk/puzzle": [
		64950,
		64950
	],
	"./kk/puzzle.json": [
		64950,
		64950
	],
	"./kk/register": [
		7776,
		7776
	],
	"./kk/register.json": [
		7776,
		7776
	],
	"./kk/settings": [
		96972,
		96972
	],
	"./kk/settings.json": [
		96972,
		96972
	],
	"./kn/analysis": [
		2967,
		2967
	],
	"./kn/analysis.json": [
		2967,
		2967
	],
	"./kn/challenge": [
		24107,
		24107
	],
	"./kn/challenge.json": [
		24107,
		24107
	],
	"./kn/common": [
		7591,
		7591
	],
	"./kn/common.json": [
		7591,
		7591
	],
	"./kn/friends": [
		56022,
		56022
	],
	"./kn/friends.json": [
		56022,
		56022
	],
	"./kn/home": [
		33129,
		33129
	],
	"./kn/home.json": [
		33129,
		33129
	],
	"./kn/leagues": [
		68521,
		68521
	],
	"./kn/leagues.json": [
		68521,
		68521
	],
	"./kn/lobby": [
		88324,
		88324
	],
	"./kn/lobby.json": [
		88324,
		88324
	],
	"./kn/players": [
		4720,
		4720
	],
	"./kn/players.json": [
		4720,
		4720
	],
	"./kn/profile": [
		78199,
		78199
	],
	"./kn/profile.json": [
		78199,
		78199
	],
	"./kn/puzzle": [
		90590,
		90590
	],
	"./kn/puzzle.json": [
		90590,
		90590
	],
	"./kn/register": [
		12974,
		12974
	],
	"./kn/register.json": [
		12974,
		12974
	],
	"./kn/settings": [
		67397,
		67397
	],
	"./kn/settings.json": [
		67397,
		67397
	],
	"./ko/analysis": [
		62710,
		62710
	],
	"./ko/analysis.json": [
		62710,
		62710
	],
	"./ko/challenge": [
		41550,
		41550
	],
	"./ko/challenge.json": [
		41550,
		41550
	],
	"./ko/common": [
		95271,
		95271
	],
	"./ko/common.json": [
		95271,
		95271
	],
	"./ko/friends": [
		76427,
		76427
	],
	"./ko/friends.json": [
		76427,
		76427
	],
	"./ko/home": [
		12853,
		12853
	],
	"./ko/home.json": [
		12853,
		12853
	],
	"./ko/leagues": [
		9987,
		9987
	],
	"./ko/leagues.json": [
		9987,
		9987
	],
	"./ko/lobby": [
		54977,
		54977
	],
	"./ko/lobby.json": [
		54977,
		54977
	],
	"./ko/players": [
		77054,
		77054
	],
	"./ko/players.json": [
		77054,
		77054
	],
	"./ko/profile": [
		40218,
		40218
	],
	"./ko/profile.json": [
		40218,
		40218
	],
	"./ko/puzzle": [
		63595,
		63595
	],
	"./ko/puzzle.json": [
		63595,
		63595
	],
	"./ko/register": [
		47683,
		47683
	],
	"./ko/register.json": [
		47683,
		47683
	],
	"./ko/settings": [
		80979,
		80979
	],
	"./ko/settings.json": [
		80979,
		80979
	],
	"./lt/analysis": [
		31226,
		31226
	],
	"./lt/analysis.json": [
		31226,
		31226
	],
	"./lt/challenge": [
		76309,
		76309
	],
	"./lt/challenge.json": [
		76309,
		76309
	],
	"./lt/common": [
		15064,
		15064
	],
	"./lt/common.json": [
		15064,
		15064
	],
	"./lt/friends": [
		21868,
		21868
	],
	"./lt/friends.json": [
		21868,
		21868
	],
	"./lt/home": [
		33266,
		33266
	],
	"./lt/home.json": [
		33266,
		33266
	],
	"./lt/leagues": [
		99277,
		99277
	],
	"./lt/leagues.json": [
		99277,
		99277
	],
	"./lt/lobby": [
		88709,
		88709
	],
	"./lt/lobby.json": [
		88709,
		88709
	],
	"./lt/players": [
		52515,
		52515
	],
	"./lt/players.json": [
		52515,
		52515
	],
	"./lt/profile": [
		7872,
		7872
	],
	"./lt/profile.json": [
		7872,
		7872
	],
	"./lt/puzzle": [
		18426,
		18426
	],
	"./lt/puzzle.json": [
		18426,
		18426
	],
	"./lt/register": [
		127,
		127
	],
	"./lt/register.json": [
		127,
		127
	],
	"./lt/settings": [
		59544,
		59544
	],
	"./lt/settings.json": [
		59544,
		59544
	],
	"./lv/analysis": [
		75435,
		75435
	],
	"./lv/analysis.json": [
		75435,
		75435
	],
	"./lv/challenge": [
		60425,
		60425
	],
	"./lv/challenge.json": [
		60425,
		60425
	],
	"./lv/common": [
		95224,
		95224
	],
	"./lv/common.json": [
		95224,
		95224
	],
	"./lv/friends": [
		58734,
		58734
	],
	"./lv/friends.json": [
		58734,
		58734
	],
	"./lv/home": [
		56681,
		56681
	],
	"./lv/home.json": [
		56681,
		56681
	],
	"./lv/leagues": [
		77294,
		77294
	],
	"./lv/leagues.json": [
		77294,
		77294
	],
	"./lv/lobby": [
		89192,
		89192
	],
	"./lv/lobby.json": [
		89192,
		89192
	],
	"./lv/players": [
		62562,
		62562
	],
	"./lv/players.json": [
		62562,
		62562
	],
	"./lv/profile": [
		70672,
		70672
	],
	"./lv/profile.json": [
		70672,
		70672
	],
	"./lv/puzzle": [
		51512,
		51512
	],
	"./lv/puzzle.json": [
		51512,
		51512
	],
	"./lv/register": [
		44226,
		44226
	],
	"./lv/register.json": [
		44226,
		44226
	],
	"./lv/settings": [
		44033,
		44033
	],
	"./lv/settings.json": [
		44033,
		44033
	],
	"./ml/analysis": [
		97089,
		97089
	],
	"./ml/analysis.json": [
		97089,
		97089
	],
	"./ml/challenge": [
		96506,
		96506
	],
	"./ml/challenge.json": [
		96506,
		96506
	],
	"./ml/common": [
		6091,
		6091
	],
	"./ml/common.json": [
		6091,
		6091
	],
	"./ml/friends": [
		15176,
		15176
	],
	"./ml/friends.json": [
		15176,
		15176
	],
	"./ml/home": [
		98664,
		98664
	],
	"./ml/home.json": [
		98664,
		98664
	],
	"./ml/leagues": [
		83571,
		83571
	],
	"./ml/leagues.json": [
		83571,
		83571
	],
	"./ml/lobby": [
		91042,
		91042
	],
	"./ml/lobby.json": [
		91042,
		91042
	],
	"./ml/players": [
		25300,
		25300
	],
	"./ml/players.json": [
		25300,
		25300
	],
	"./ml/profile": [
		85881,
		85881
	],
	"./ml/profile.json": [
		85881,
		85881
	],
	"./ml/puzzle": [
		42623,
		42623
	],
	"./ml/puzzle.json": [
		42623,
		42623
	],
	"./ml/register": [
		53107,
		53107
	],
	"./ml/register.json": [
		53107,
		53107
	],
	"./ml/settings": [
		80243,
		80243
	],
	"./ml/settings.json": [
		80243,
		80243
	],
	"./mn/analysis": [
		60423,
		60423
	],
	"./mn/analysis.json": [
		60423,
		60423
	],
	"./mn/challenge": [
		47571,
		47571
	],
	"./mn/challenge.json": [
		47571,
		47571
	],
	"./mn/common": [
		20211,
		20211
	],
	"./mn/common.json": [
		20211,
		20211
	],
	"./mn/friends": [
		75640,
		75640
	],
	"./mn/friends.json": [
		75640,
		75640
	],
	"./mn/home": [
		68493,
		68493
	],
	"./mn/home.json": [
		68493,
		68493
	],
	"./mn/leagues": [
		978,
		978
	],
	"./mn/leagues.json": [
		978,
		978
	],
	"./mn/lobby": [
		34644,
		34644
	],
	"./mn/lobby.json": [
		34644,
		34644
	],
	"./mn/players": [
		96159,
		96159
	],
	"./mn/players.json": [
		96159,
		96159
	],
	"./mn/profile": [
		21814,
		21814
	],
	"./mn/profile.json": [
		21814,
		21814
	],
	"./mn/puzzle": [
		90758,
		90758
	],
	"./mn/puzzle.json": [
		90758,
		90758
	],
	"./mn/register": [
		13013,
		13013
	],
	"./mn/register.json": [
		13013,
		13013
	],
	"./mn/settings": [
		56672,
		56672
	],
	"./mn/settings.json": [
		56672,
		56672
	],
	"./mr/analysis": [
		30127,
		30127
	],
	"./mr/analysis.json": [
		30127,
		30127
	],
	"./mr/challenge": [
		45919,
		45919
	],
	"./mr/challenge.json": [
		45919,
		45919
	],
	"./mr/common": [
		26419,
		26419
	],
	"./mr/common.json": [
		26419,
		26419
	],
	"./mr/friends": [
		52712,
		52712
	],
	"./mr/friends.json": [
		52712,
		52712
	],
	"./mr/home": [
		17196,
		17196
	],
	"./mr/home.json": [
		17196,
		17196
	],
	"./mr/leagues": [
		57715,
		57715
	],
	"./mr/leagues.json": [
		57715,
		57715
	],
	"./mr/lobby": [
		82748,
		82748
	],
	"./mr/lobby.json": [
		82748,
		82748
	],
	"./mr/players": [
		58832,
		58832
	],
	"./mr/players.json": [
		58832,
		58832
	],
	"./mr/profile": [
		42108,
		42108
	],
	"./mr/profile.json": [
		42108,
		42108
	],
	"./mr/puzzle": [
		14249,
		14249
	],
	"./mr/puzzle.json": [
		14249,
		14249
	],
	"./mr/register": [
		56015,
		56015
	],
	"./mr/register.json": [
		56015,
		56015
	],
	"./mr/settings": [
		35369,
		35369
	],
	"./mr/settings.json": [
		35369,
		35369
	],
	"./nb/analysis": [
		54410,
		54410
	],
	"./nb/analysis.json": [
		54410,
		54410
	],
	"./nb/challenge": [
		41122,
		41122
	],
	"./nb/challenge.json": [
		41122,
		41122
	],
	"./nb/common": [
		92530,
		92530
	],
	"./nb/common.json": [
		92530,
		92530
	],
	"./nb/friends": [
		99500,
		99500
	],
	"./nb/friends.json": [
		99500,
		99500
	],
	"./nb/home": [
		55247,
		55247
	],
	"./nb/home.json": [
		55247,
		55247
	],
	"./nb/leagues": [
		8334,
		8334
	],
	"./nb/leagues.json": [
		8334,
		8334
	],
	"./nb/lobby": [
		77075,
		77075
	],
	"./nb/lobby.json": [
		77075,
		77075
	],
	"./nb/players": [
		932,
		932
	],
	"./nb/players.json": [
		932,
		932
	],
	"./nb/profile": [
		61967,
		61967
	],
	"./nb/profile.json": [
		61967,
		61967
	],
	"./nb/puzzle": [
		28982,
		28982
	],
	"./nb/puzzle.json": [
		28982,
		28982
	],
	"./nb/register": [
		74484,
		74484
	],
	"./nb/register.json": [
		74484,
		74484
	],
	"./nb/settings": [
		98795,
		16478
	],
	"./nb/settings.json": [
		98795,
		16478
	],
	"./nl/analysis": [
		99108,
		99108
	],
	"./nl/analysis.json": [
		99108,
		99108
	],
	"./nl/challenge": [
		14513,
		14513
	],
	"./nl/challenge.json": [
		14513,
		14513
	],
	"./nl/common": [
		1211,
		1211
	],
	"./nl/common.json": [
		1211,
		1211
	],
	"./nl/friends": [
		27491,
		27491
	],
	"./nl/friends.json": [
		27491,
		27491
	],
	"./nl/home": [
		86385,
		86385
	],
	"./nl/home.json": [
		86385,
		86385
	],
	"./nl/leagues": [
		86892,
		86892
	],
	"./nl/leagues.json": [
		86892,
		86892
	],
	"./nl/lobby": [
		6071,
		6071
	],
	"./nl/lobby.json": [
		6071,
		6071
	],
	"./nl/players": [
		66089,
		66089
	],
	"./nl/players.json": [
		66089,
		66089
	],
	"./nl/profile": [
		86583,
		86583
	],
	"./nl/profile.json": [
		86583,
		86583
	],
	"./nl/puzzle": [
		95877,
		95877
	],
	"./nl/puzzle.json": [
		95877,
		95877
	],
	"./nl/register": [
		31814,
		31814
	],
	"./nl/register.json": [
		31814,
		31814
	],
	"./nl/settings": [
		76440,
		76440
	],
	"./nl/settings.json": [
		76440,
		76440
	],
	"./pl/analysis": [
		80325,
		80325
	],
	"./pl/analysis.json": [
		80325,
		80325
	],
	"./pl/challenge": [
		16346,
		16346
	],
	"./pl/challenge.json": [
		16346,
		16346
	],
	"./pl/common": [
		45878,
		45878
	],
	"./pl/common.json": [
		45878,
		45878
	],
	"./pl/friends": [
		2592,
		2592
	],
	"./pl/friends.json": [
		2592,
		2592
	],
	"./pl/home": [
		8797,
		8797
	],
	"./pl/home.json": [
		8797,
		8797
	],
	"./pl/leagues": [
		43131,
		43131
	],
	"./pl/leagues.json": [
		43131,
		43131
	],
	"./pl/lobby": [
		72721,
		72721
	],
	"./pl/lobby.json": [
		72721,
		72721
	],
	"./pl/players": [
		70124,
		70124
	],
	"./pl/players.json": [
		70124,
		70124
	],
	"./pl/profile": [
		79196,
		79196
	],
	"./pl/profile.json": [
		79196,
		79196
	],
	"./pl/puzzle": [
		20760,
		20760
	],
	"./pl/puzzle.json": [
		20760,
		20760
	],
	"./pl/register": [
		81244,
		81244
	],
	"./pl/register.json": [
		81244,
		81244
	],
	"./pl/settings": [
		43070,
		43070
	],
	"./pl/settings.json": [
		43070,
		43070
	],
	"./ps/analysis": [
		80833,
		80833
	],
	"./ps/analysis.json": [
		80833,
		80833
	],
	"./ps/challenge": [
		18681,
		18681
	],
	"./ps/challenge.json": [
		18681,
		18681
	],
	"./ps/common": [
		36645,
		36645
	],
	"./ps/common.json": [
		36645,
		36645
	],
	"./ps/friends": [
		66589,
		66589
	],
	"./ps/friends.json": [
		66589,
		66589
	],
	"./ps/home": [
		42278,
		42278
	],
	"./ps/home.json": [
		42278,
		42278
	],
	"./ps/leagues": [
		65351,
		65351
	],
	"./ps/leagues.json": [
		65351,
		65351
	],
	"./ps/lobby": [
		93210,
		93210
	],
	"./ps/lobby.json": [
		93210,
		93210
	],
	"./ps/players": [
		18503,
		18503
	],
	"./ps/players.json": [
		18503,
		18503
	],
	"./ps/profile": [
		53324,
		53324
	],
	"./ps/profile.json": [
		53324,
		53324
	],
	"./ps/puzzle": [
		78906,
		78906
	],
	"./ps/puzzle.json": [
		78906,
		78906
	],
	"./ps/register": [
		21671,
		21671
	],
	"./ps/register.json": [
		21671,
		21671
	],
	"./ps/settings": [
		84986,
		84986
	],
	"./ps/settings.json": [
		84986,
		84986
	],
	"./pt-PT/analysis": [
		5113,
		5113
	],
	"./pt-PT/analysis.json": [
		5113,
		5113
	],
	"./pt-PT/challenge": [
		59450,
		59450
	],
	"./pt-PT/challenge.json": [
		59450,
		59450
	],
	"./pt-PT/common": [
		17294,
		17294
	],
	"./pt-PT/common.json": [
		17294,
		17294
	],
	"./pt-PT/friends": [
		82476,
		82476
	],
	"./pt-PT/friends.json": [
		82476,
		82476
	],
	"./pt-PT/home": [
		71124,
		71124
	],
	"./pt-PT/home.json": [
		71124,
		71124
	],
	"./pt-PT/leagues": [
		67305,
		67305
	],
	"./pt-PT/leagues.json": [
		67305,
		67305
	],
	"./pt-PT/lobby": [
		50785,
		50785
	],
	"./pt-PT/lobby.json": [
		50785,
		50785
	],
	"./pt-PT/players": [
		16395,
		16395
	],
	"./pt-PT/players.json": [
		16395,
		16395
	],
	"./pt-PT/profile": [
		76399,
		76399
	],
	"./pt-PT/profile.json": [
		76399,
		76399
	],
	"./pt-PT/puzzle": [
		54161,
		54161
	],
	"./pt-PT/puzzle.json": [
		54161,
		54161
	],
	"./pt-PT/register": [
		34683,
		34683
	],
	"./pt-PT/register.json": [
		34683,
		34683
	],
	"./pt-PT/settings": [
		2522,
		2522
	],
	"./pt-PT/settings.json": [
		2522,
		2522
	],
	"./pt/analysis": [
		22077,
		22077
	],
	"./pt/analysis.json": [
		22077,
		22077
	],
	"./pt/challenge": [
		38301,
		38301
	],
	"./pt/challenge.json": [
		38301,
		38301
	],
	"./pt/common": [
		41400,
		41400
	],
	"./pt/common.json": [
		41400,
		41400
	],
	"./pt/friends": [
		84205,
		84205
	],
	"./pt/friends.json": [
		84205,
		84205
	],
	"./pt/gamePlay": [
		29157,
		29157
	],
	"./pt/gamePlay.json": [
		29157,
		29157
	],
	"./pt/home": [
		44766,
		44766
	],
	"./pt/home.json": [
		44766,
		44766
	],
	"./pt/leagues": [
		51580,
		51580
	],
	"./pt/leagues.json": [
		51580,
		51580
	],
	"./pt/lobby": [
		365,
		365
	],
	"./pt/lobby.json": [
		365,
		365
	],
	"./pt/notUsed/daily": [
		48394,
		48394
	],
	"./pt/notUsed/daily.json": [
		48394,
		48394
	],
	"./pt/notUsed/extra": [
		50674,
		50674
	],
	"./pt/notUsed/extra.json": [
		50674,
		50674
	],
	"./pt/notUsed/navigation": [
		67945,
		67945
	],
	"./pt/notUsed/navigation.json": [
		67945,
		67945
	],
	"./pt/notUsed/notUsed": [
		17167,
		17167
	],
	"./pt/notUsed/notUsed.json": [
		17167,
		17167
	],
	"./pt/players": [
		3835,
		3835
	],
	"./pt/players.json": [
		3835,
		3835
	],
	"./pt/profile": [
		22854,
		22854
	],
	"./pt/profile.json": [
		22854,
		22854
	],
	"./pt/puzzle": [
		74791,
		74791
	],
	"./pt/puzzle.json": [
		74791,
		74791
	],
	"./pt/register": [
		63127,
		63127
	],
	"./pt/register.json": [
		63127,
		63127
	],
	"./pt/settings": [
		52877,
		52877
	],
	"./pt/settings.json": [
		52877,
		52877
	],
	"./ro/analysis": [
		5066,
		5066
	],
	"./ro/analysis.json": [
		5066,
		5066
	],
	"./ro/challenge": [
		17975,
		17975
	],
	"./ro/challenge.json": [
		17975,
		17975
	],
	"./ro/common": [
		4686,
		4686
	],
	"./ro/common.json": [
		4686,
		4686
	],
	"./ro/friends": [
		32568,
		32568
	],
	"./ro/friends.json": [
		32568,
		32568
	],
	"./ro/home": [
		10153,
		10153
	],
	"./ro/home.json": [
		10153,
		10153
	],
	"./ro/leagues": [
		86373,
		86373
	],
	"./ro/leagues.json": [
		86373,
		86373
	],
	"./ro/lobby": [
		48909,
		48909
	],
	"./ro/lobby.json": [
		48909,
		48909
	],
	"./ro/players": [
		58714,
		58714
	],
	"./ro/players.json": [
		58714,
		58714
	],
	"./ro/profile": [
		5277,
		5277
	],
	"./ro/profile.json": [
		5277,
		5277
	],
	"./ro/puzzle": [
		37930,
		37930
	],
	"./ro/puzzle.json": [
		37930,
		37930
	],
	"./ro/register": [
		50560,
		50560
	],
	"./ro/register.json": [
		50560,
		50560
	],
	"./ro/settings": [
		73510,
		73510
	],
	"./ro/settings.json": [
		73510,
		73510
	],
	"./ru/analysis": [
		39608,
		39608
	],
	"./ru/analysis.json": [
		39608,
		39608
	],
	"./ru/challenge": [
		4360,
		4360
	],
	"./ru/challenge.json": [
		4360,
		4360
	],
	"./ru/common": [
		77247,
		77247
	],
	"./ru/common.json": [
		77247,
		77247
	],
	"./ru/friends": [
		96479,
		96479
	],
	"./ru/friends.json": [
		96479,
		96479
	],
	"./ru/gamePlay": [
		16119,
		16119
	],
	"./ru/gamePlay.json": [
		16119,
		16119
	],
	"./ru/home": [
		32503,
		32503
	],
	"./ru/home.json": [
		32503,
		32503
	],
	"./ru/leagues": [
		14592,
		14592
	],
	"./ru/leagues.json": [
		14592,
		14592
	],
	"./ru/lobby": [
		68040,
		68040
	],
	"./ru/lobby.json": [
		68040,
		68040
	],
	"./ru/notUsed/daily": [
		19179,
		19179
	],
	"./ru/notUsed/daily.json": [
		19179,
		19179
	],
	"./ru/notUsed/extra": [
		74265,
		74265
	],
	"./ru/notUsed/extra.json": [
		74265,
		74265
	],
	"./ru/notUsed/navigation": [
		91328,
		91328
	],
	"./ru/notUsed/navigation.json": [
		91328,
		91328
	],
	"./ru/notUsed/notUsed": [
		36729,
		36729
	],
	"./ru/notUsed/notUsed.json": [
		36729,
		36729
	],
	"./ru/players": [
		99341,
		99341
	],
	"./ru/players.json": [
		99341,
		99341
	],
	"./ru/profile": [
		87157,
		87157
	],
	"./ru/profile.json": [
		87157,
		87157
	],
	"./ru/puzzle": [
		32668,
		32668
	],
	"./ru/puzzle.json": [
		32668,
		32668
	],
	"./ru/register": [
		96187,
		96187
	],
	"./ru/register.json": [
		96187,
		96187
	],
	"./ru/settings": [
		54770,
		54770
	],
	"./ru/settings.json": [
		54770,
		54770
	],
	"./sk/analysis": [
		59036,
		59036
	],
	"./sk/analysis.json": [
		59036,
		59036
	],
	"./sk/challenge": [
		22416,
		22416
	],
	"./sk/challenge.json": [
		22416,
		22416
	],
	"./sk/common": [
		25446,
		25446
	],
	"./sk/common.json": [
		25446,
		25446
	],
	"./sk/friends": [
		71206,
		71206
	],
	"./sk/friends.json": [
		71206,
		71206
	],
	"./sk/home": [
		10238,
		10238
	],
	"./sk/home.json": [
		10238,
		10238
	],
	"./sk/leagues": [
		88165,
		88165
	],
	"./sk/leagues.json": [
		88165,
		88165
	],
	"./sk/lobby": [
		56625,
		56625
	],
	"./sk/lobby.json": [
		56625,
		56625
	],
	"./sk/players": [
		14151,
		14151
	],
	"./sk/players.json": [
		14151,
		14151
	],
	"./sk/profile": [
		51682,
		51682
	],
	"./sk/profile.json": [
		51682,
		51682
	],
	"./sk/puzzle": [
		40314,
		40314
	],
	"./sk/puzzle.json": [
		40314,
		40314
	],
	"./sk/register": [
		61128,
		61128
	],
	"./sk/register.json": [
		61128,
		61128
	],
	"./sk/settings": [
		70509,
		70509
	],
	"./sk/settings.json": [
		70509,
		70509
	],
	"./sl/analysis": [
		18579,
		18579
	],
	"./sl/analysis.json": [
		18579,
		18579
	],
	"./sl/challenge": [
		52881,
		52881
	],
	"./sl/challenge.json": [
		52881,
		52881
	],
	"./sl/common": [
		52068,
		52068
	],
	"./sl/common.json": [
		52068,
		52068
	],
	"./sl/friends": [
		76787,
		76787
	],
	"./sl/friends.json": [
		76787,
		76787
	],
	"./sl/home": [
		58486,
		58486
	],
	"./sl/home.json": [
		58486,
		58486
	],
	"./sl/leagues": [
		51451,
		51451
	],
	"./sl/leagues.json": [
		51451,
		51451
	],
	"./sl/lobby": [
		85306,
		85306
	],
	"./sl/lobby.json": [
		85306,
		85306
	],
	"./sl/players": [
		59919,
		59919
	],
	"./sl/players.json": [
		59919,
		59919
	],
	"./sl/profile": [
		35120,
		35120
	],
	"./sl/profile.json": [
		35120,
		35120
	],
	"./sl/puzzle": [
		73820,
		73820
	],
	"./sl/puzzle.json": [
		73820,
		73820
	],
	"./sl/register": [
		95736,
		95736
	],
	"./sl/register.json": [
		95736,
		95736
	],
	"./sl/settings": [
		26338,
		26338
	],
	"./sl/settings.json": [
		26338,
		26338
	],
	"./sr/analysis": [
		43957,
		43957
	],
	"./sr/analysis.json": [
		43957,
		43957
	],
	"./sr/challenge": [
		69610,
		69610
	],
	"./sr/challenge.json": [
		69610,
		69610
	],
	"./sr/common": [
		13911,
		13911
	],
	"./sr/common.json": [
		13911,
		13911
	],
	"./sr/friends": [
		54279,
		54279
	],
	"./sr/friends.json": [
		54279,
		54279
	],
	"./sr/home": [
		78793,
		78793
	],
	"./sr/home.json": [
		78793,
		78793
	],
	"./sr/leagues": [
		65694,
		65694
	],
	"./sr/leagues.json": [
		65694,
		65694
	],
	"./sr/lobby": [
		36836,
		36836
	],
	"./sr/lobby.json": [
		36836,
		36836
	],
	"./sr/players": [
		19052,
		19052
	],
	"./sr/players.json": [
		19052,
		19052
	],
	"./sr/profile": [
		37846,
		37846
	],
	"./sr/profile.json": [
		37846,
		37846
	],
	"./sr/puzzle": [
		30663,
		30663
	],
	"./sr/puzzle.json": [
		30663,
		30663
	],
	"./sr/register": [
		35129,
		35129
	],
	"./sr/register.json": [
		35129,
		35129
	],
	"./sr/settings": [
		71472,
		71472
	],
	"./sr/settings.json": [
		71472,
		71472
	],
	"./sv/analysis": [
		60759,
		60759
	],
	"./sv/analysis.json": [
		60759,
		60759
	],
	"./sv/category": [
		32501,
		32501
	],
	"./sv/category.json": [
		32501,
		32501
	],
	"./sv/challenge": [
		97516,
		97516
	],
	"./sv/challenge.json": [
		97516,
		97516
	],
	"./sv/common": [
		56504,
		56504
	],
	"./sv/common.json": [
		56504,
		56504
	],
	"./sv/friends": [
		42100,
		42100
	],
	"./sv/friends.json": [
		42100,
		42100
	],
	"./sv/gamePlay": [
		42608,
		42608
	],
	"./sv/gamePlay.json": [
		42608,
		42608
	],
	"./sv/home": [
		17099,
		17099
	],
	"./sv/home.json": [
		17099,
		17099
	],
	"./sv/leagues": [
		87000,
		87000
	],
	"./sv/leagues.json": [
		87000,
		87000
	],
	"./sv/lobby": [
		19892,
		19892
	],
	"./sv/lobby.json": [
		19892,
		19892
	],
	"./sv/notUsed/daily": [
		78067,
		78067
	],
	"./sv/notUsed/daily.json": [
		78067,
		78067
	],
	"./sv/notUsed/extra": [
		80936,
		80936
	],
	"./sv/notUsed/extra.json": [
		80936,
		80936
	],
	"./sv/notUsed/navigation": [
		49833,
		49833
	],
	"./sv/notUsed/navigation.json": [
		49833,
		49833
	],
	"./sv/notUsed/notUsed": [
		1424,
		1424
	],
	"./sv/notUsed/notUsed.json": [
		1424,
		1424
	],
	"./sv/players": [
		97718,
		97718
	],
	"./sv/players.json": [
		97718,
		97718
	],
	"./sv/profile": [
		66281,
		66281
	],
	"./sv/profile.json": [
		66281,
		66281
	],
	"./sv/puzzle": [
		43122,
		43122
	],
	"./sv/puzzle.json": [
		43122,
		43122
	],
	"./sv/register": [
		15349,
		15349
	],
	"./sv/register.json": [
		15349,
		15349
	],
	"./sv/settings": [
		76511,
		76511
	],
	"./sv/settings.json": [
		76511,
		76511
	],
	"./sw/analysis": [
		72521,
		72521
	],
	"./sw/analysis.json": [
		72521,
		72521
	],
	"./sw/challenge": [
		46782,
		46782
	],
	"./sw/challenge.json": [
		46782,
		46782
	],
	"./sw/common": [
		21124,
		21124
	],
	"./sw/common.json": [
		21124,
		21124
	],
	"./sw/friends": [
		46431,
		46431
	],
	"./sw/friends.json": [
		46431,
		46431
	],
	"./sw/home": [
		28227,
		28227
	],
	"./sw/home.json": [
		28227,
		28227
	],
	"./sw/leagues": [
		4562,
		4562
	],
	"./sw/leagues.json": [
		4562,
		4562
	],
	"./sw/lobby": [
		66495,
		60648
	],
	"./sw/lobby.json": [
		66495,
		60648
	],
	"./sw/players": [
		26802,
		26802
	],
	"./sw/players.json": [
		26802,
		26802
	],
	"./sw/profile": [
		38182,
		38182
	],
	"./sw/profile.json": [
		38182,
		38182
	],
	"./sw/puzzle": [
		69561,
		69561
	],
	"./sw/puzzle.json": [
		69561,
		69561
	],
	"./sw/register": [
		87444,
		87444
	],
	"./sw/register.json": [
		87444,
		87444
	],
	"./sw/settings": [
		74326,
		74326
	],
	"./sw/settings.json": [
		74326,
		74326
	],
	"./th/analysis": [
		78487,
		78487
	],
	"./th/analysis.json": [
		78487,
		78487
	],
	"./th/challenge": [
		40057,
		40057
	],
	"./th/challenge.json": [
		40057,
		40057
	],
	"./th/common": [
		63303,
		63303
	],
	"./th/common.json": [
		63303,
		63303
	],
	"./th/friends": [
		69236,
		69236
	],
	"./th/friends.json": [
		69236,
		69236
	],
	"./th/home": [
		61686,
		61686
	],
	"./th/home.json": [
		61686,
		61686
	],
	"./th/leagues": [
		34076,
		34076
	],
	"./th/leagues.json": [
		34076,
		34076
	],
	"./th/lobby": [
		31618,
		31618
	],
	"./th/lobby.json": [
		31618,
		31618
	],
	"./th/players": [
		94793,
		94793
	],
	"./th/players.json": [
		94793,
		94793
	],
	"./th/profile": [
		43671,
		43671
	],
	"./th/profile.json": [
		43671,
		43671
	],
	"./th/puzzle": [
		70443,
		70443
	],
	"./th/puzzle.json": [
		70443,
		70443
	],
	"./th/register": [
		62688,
		62688
	],
	"./th/register.json": [
		62688,
		62688
	],
	"./th/settings": [
		42319,
		42319
	],
	"./th/settings.json": [
		42319,
		42319
	],
	"./tk/analysis": [
		87620,
		87620
	],
	"./tk/analysis.json": [
		87620,
		87620
	],
	"./tk/challenge": [
		63186,
		63186
	],
	"./tk/challenge.json": [
		63186,
		63186
	],
	"./tk/common": [
		72923,
		72923
	],
	"./tk/common.json": [
		72923,
		72923
	],
	"./tk/friends": [
		93822,
		93822
	],
	"./tk/friends.json": [
		93822,
		93822
	],
	"./tk/home": [
		57028,
		57028
	],
	"./tk/home.json": [
		57028,
		57028
	],
	"./tk/leagues": [
		67904,
		67904
	],
	"./tk/leagues.json": [
		67904,
		67904
	],
	"./tk/lobby": [
		46586,
		46586
	],
	"./tk/lobby.json": [
		46586,
		46586
	],
	"./tk/players": [
		1686,
		1686
	],
	"./tk/players.json": [
		1686,
		1686
	],
	"./tk/profile": [
		91191,
		91191
	],
	"./tk/profile.json": [
		91191,
		91191
	],
	"./tk/puzzle": [
		90168,
		90168
	],
	"./tk/puzzle.json": [
		90168,
		90168
	],
	"./tk/register": [
		99166,
		63740
	],
	"./tk/register.json": [
		99166,
		63740
	],
	"./tk/settings": [
		87077,
		87077
	],
	"./tk/settings.json": [
		87077,
		87077
	],
	"./tr/analysis": [
		40237,
		40237
	],
	"./tr/analysis.json": [
		40237,
		40237
	],
	"./tr/challenge": [
		21388,
		21388
	],
	"./tr/challenge.json": [
		21388,
		21388
	],
	"./tr/common": [
		72973,
		72973
	],
	"./tr/common.json": [
		72973,
		72973
	],
	"./tr/friends": [
		65740,
		65740
	],
	"./tr/friends.json": [
		65740,
		65740
	],
	"./tr/home": [
		27646,
		27646
	],
	"./tr/home.json": [
		27646,
		27646
	],
	"./tr/leagues": [
		65121,
		65121
	],
	"./tr/leagues.json": [
		65121,
		65121
	],
	"./tr/lobby": [
		52050,
		52050
	],
	"./tr/lobby.json": [
		52050,
		52050
	],
	"./tr/players": [
		15611,
		15611
	],
	"./tr/players.json": [
		15611,
		15611
	],
	"./tr/profile": [
		52140,
		52140
	],
	"./tr/profile.json": [
		52140,
		52140
	],
	"./tr/puzzle": [
		65648,
		65648
	],
	"./tr/puzzle.json": [
		65648,
		65648
	],
	"./tr/register": [
		54664,
		54664
	],
	"./tr/register.json": [
		54664,
		54664
	],
	"./tr/settings": [
		46561,
		46561
	],
	"./tr/settings.json": [
		46561,
		46561
	],
	"./uk/analysis": [
		54959,
		54959
	],
	"./uk/analysis.json": [
		54959,
		54959
	],
	"./uk/challenge": [
		78966,
		78966
	],
	"./uk/challenge.json": [
		78966,
		78966
	],
	"./uk/common": [
		98783,
		98783
	],
	"./uk/common.json": [
		98783,
		98783
	],
	"./uk/friends": [
		42773,
		42773
	],
	"./uk/friends.json": [
		42773,
		42773
	],
	"./uk/home": [
		58133,
		58133
	],
	"./uk/home.json": [
		58133,
		58133
	],
	"./uk/leagues": [
		93377,
		93377
	],
	"./uk/leagues.json": [
		93377,
		93377
	],
	"./uk/lobby": [
		15268,
		15268
	],
	"./uk/lobby.json": [
		15268,
		15268
	],
	"./uk/players": [
		38229,
		38229
	],
	"./uk/players.json": [
		38229,
		38229
	],
	"./uk/profile": [
		43212,
		43212
	],
	"./uk/profile.json": [
		43212,
		43212
	],
	"./uk/puzzle": [
		60317,
		60317
	],
	"./uk/puzzle.json": [
		60317,
		60317
	],
	"./uk/register": [
		56808,
		56808
	],
	"./uk/register.json": [
		56808,
		56808
	],
	"./uk/settings": [
		39149,
		39149
	],
	"./uk/settings.json": [
		39149,
		39149
	],
	"./ur/analysis": [
		9958,
		9958
	],
	"./ur/analysis.json": [
		9958,
		9958
	],
	"./ur/challenge": [
		7804,
		7804
	],
	"./ur/challenge.json": [
		7804,
		7804
	],
	"./ur/common": [
		45597,
		45597
	],
	"./ur/common.json": [
		45597,
		45597
	],
	"./ur/friends": [
		78816,
		78816
	],
	"./ur/friends.json": [
		78816,
		78816
	],
	"./ur/home": [
		5321,
		5321
	],
	"./ur/home.json": [
		5321,
		5321
	],
	"./ur/leagues": [
		26173,
		26173
	],
	"./ur/leagues.json": [
		26173,
		26173
	],
	"./ur/lobby": [
		96948,
		96948
	],
	"./ur/lobby.json": [
		96948,
		96948
	],
	"./ur/players": [
		20995,
		20995
	],
	"./ur/players.json": [
		20995,
		20995
	],
	"./ur/profile": [
		58438,
		58438
	],
	"./ur/profile.json": [
		58438,
		58438
	],
	"./ur/puzzle": [
		6094,
		6094
	],
	"./ur/puzzle.json": [
		6094,
		6094
	],
	"./ur/register": [
		45782,
		45782
	],
	"./ur/register.json": [
		45782,
		45782
	],
	"./ur/settings": [
		53383,
		53383
	],
	"./ur/settings.json": [
		53383,
		53383
	],
	"./uz/analysis": [
		26614,
		26614
	],
	"./uz/analysis.json": [
		26614,
		26614
	],
	"./uz/challenge": [
		21023,
		21023
	],
	"./uz/challenge.json": [
		21023,
		21023
	],
	"./uz/common": [
		76745,
		76745
	],
	"./uz/common.json": [
		76745,
		76745
	],
	"./uz/friends": [
		81024,
		81024
	],
	"./uz/friends.json": [
		81024,
		81024
	],
	"./uz/home": [
		51732,
		51732
	],
	"./uz/home.json": [
		51732,
		51732
	],
	"./uz/leagues": [
		24034,
		24034
	],
	"./uz/leagues.json": [
		24034,
		24034
	],
	"./uz/lobby": [
		14059,
		14059
	],
	"./uz/lobby.json": [
		14059,
		14059
	],
	"./uz/players": [
		43925,
		43925
	],
	"./uz/players.json": [
		43925,
		43925
	],
	"./uz/profile": [
		92732,
		92732
	],
	"./uz/profile.json": [
		92732,
		92732
	],
	"./uz/puzzle": [
		54832,
		54832
	],
	"./uz/puzzle.json": [
		54832,
		54832
	],
	"./uz/register": [
		68775,
		68775
	],
	"./uz/register.json": [
		68775,
		68775
	],
	"./uz/settings": [
		3253,
		3253
	],
	"./uz/settings.json": [
		3253,
		3253
	],
	"./vi/analysis": [
		14223,
		14223
	],
	"./vi/analysis.json": [
		14223,
		14223
	],
	"./vi/challenge": [
		34868,
		34868
	],
	"./vi/challenge.json": [
		34868,
		34868
	],
	"./vi/common": [
		79789,
		79789
	],
	"./vi/common.json": [
		79789,
		79789
	],
	"./vi/friends": [
		8321,
		8321
	],
	"./vi/friends.json": [
		8321,
		8321
	],
	"./vi/home": [
		94366,
		94366
	],
	"./vi/home.json": [
		94366,
		94366
	],
	"./vi/leagues": [
		9214,
		9214
	],
	"./vi/leagues.json": [
		9214,
		9214
	],
	"./vi/lobby": [
		90763,
		90763
	],
	"./vi/lobby.json": [
		90763,
		90763
	],
	"./vi/players": [
		81313,
		81313
	],
	"./vi/players.json": [
		81313,
		81313
	],
	"./vi/profile": [
		32674,
		32674
	],
	"./vi/profile.json": [
		32674,
		32674
	],
	"./vi/puzzle": [
		54303,
		54303
	],
	"./vi/puzzle.json": [
		54303,
		54303
	],
	"./vi/register": [
		98897,
		98897
	],
	"./vi/register.json": [
		98897,
		98897
	],
	"./vi/settings": [
		41548,
		41548
	],
	"./vi/settings.json": [
		41548,
		41548
	],
	"./zh-CN/analysis": [
		56950,
		56950
	],
	"./zh-CN/analysis.json": [
		56950,
		56950
	],
	"./zh-CN/challenge": [
		50231,
		50231
	],
	"./zh-CN/challenge.json": [
		50231,
		50231
	],
	"./zh-CN/common": [
		45807,
		45807
	],
	"./zh-CN/common.json": [
		45807,
		45807
	],
	"./zh-CN/friends": [
		23059,
		23059
	],
	"./zh-CN/friends.json": [
		23059,
		23059
	],
	"./zh-CN/home": [
		5520,
		5520
	],
	"./zh-CN/home.json": [
		5520,
		5520
	],
	"./zh-CN/leagues": [
		41768,
		41768
	],
	"./zh-CN/leagues.json": [
		41768,
		41768
	],
	"./zh-CN/lobby": [
		44388,
		44388
	],
	"./zh-CN/lobby.json": [
		44388,
		44388
	],
	"./zh-CN/players": [
		73347,
		73347
	],
	"./zh-CN/players.json": [
		73347,
		73347
	],
	"./zh-CN/profile": [
		38593,
		38593
	],
	"./zh-CN/profile.json": [
		38593,
		38593
	],
	"./zh-CN/puzzle": [
		97126,
		97126
	],
	"./zh-CN/puzzle.json": [
		97126,
		97126
	],
	"./zh-CN/register": [
		41683,
		41683
	],
	"./zh-CN/register.json": [
		41683,
		41683
	],
	"./zh-CN/settings": [
		30730,
		30730
	],
	"./zh-CN/settings.json": [
		30730,
		30730
	],
	"./zh-TW/analysis": [
		16320,
		16320
	],
	"./zh-TW/analysis.json": [
		16320,
		16320
	],
	"./zh-TW/challenge": [
		93078,
		93078
	],
	"./zh-TW/challenge.json": [
		93078,
		93078
	],
	"./zh-TW/common": [
		47715,
		47715
	],
	"./zh-TW/common.json": [
		47715,
		47715
	],
	"./zh-TW/friends": [
		2796,
		2796
	],
	"./zh-TW/friends.json": [
		2796,
		2796
	],
	"./zh-TW/home": [
		54044,
		54044
	],
	"./zh-TW/home.json": [
		54044,
		54044
	],
	"./zh-TW/leagues": [
		87275,
		87275
	],
	"./zh-TW/leagues.json": [
		87275,
		87275
	],
	"./zh-TW/lobby": [
		68145,
		68145
	],
	"./zh-TW/lobby.json": [
		68145,
		68145
	],
	"./zh-TW/players": [
		3002,
		3002
	],
	"./zh-TW/players.json": [
		3002,
		3002
	],
	"./zh-TW/profile": [
		65933,
		65933
	],
	"./zh-TW/profile.json": [
		65933,
		65933
	],
	"./zh-TW/puzzle": [
		3425,
		3425
	],
	"./zh-TW/puzzle.json": [
		3425,
		3425
	],
	"./zh-TW/register": [
		33415,
		33415
	],
	"./zh-TW/register.json": [
		33415,
		33415
	],
	"./zh-TW/settings": [
		20916,
		20916
	],
	"./zh-TW/settings.json": [
		20916,
		20916
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;